import Index from '@/views/preferences/index'

const model = 'Preference'

export default [
  {
    path: '/preferences',
    name: 'preferences',
    component: Index,
    meta: { requiresAuth: true, auth: { model, permission: 'create' } }
  }
]
